import React from 'react';
import { Link } from 'react-router-dom';

const OrganicPyrolysis = () => {
    const imgMachine = '/mg22eh-machine.jpg';
    const imgDiagram = '/process-flow.jpg';
    const cardStyle = { background: '#fff', padding: '30px', borderRadius: '12px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)', marginBottom: '30px' };

    return (
        <div style={{ maxWidth: '900px', margin: '40px auto', fontFamily: 'Arial, sans-serif', padding: '0 20px' }}>
            {/* Header Section */}
            <div style={{ textAlign: 'center', marginBottom: '40px', borderBottom: '2px solid #333', paddingBottom: '20px' }}>
                <h1 style={{ color: '#1a2b4d', fontSize: '2rem', margin: '0' }}>Rajkuruma Enterprises Pvt Ltd.</h1>
                <p>375/18 Civil Lines, Gurugram, Haryana - 122001</p>
                <p>Contact: +91 9999320112 | Email: rajkurumaenterprises@gmail.com</p>
            </div>

            <h1 style={{ textAlign: 'center', color: '#b91c1c' }}>Sustainable Waste Management Solution</h1>

            <div style={cardStyle}>
                <p>The MG22Eh Organic Magnetic Pyrolysis Energy Conversion System is an advanced waste decomposition and energy recovery solution designed to support sustainable and environmentally responsible waste management practices across urban, agricultural, institutional, and industrial sectors.</p>
            </div>

            {/* System Overview Section (Image added) */}
            <div style={cardStyle}>
                <img src={imgMachine} alt="MG22Eh Machine" style={{ width: '100%', borderRadius: '8px', marginBottom: '15px' }} />
                <h2 style={{ color: '#b91c1c' }}>System Overview</h2>
                <p>Yeh system magnetism aur heat ka use karke organic matter ko decompose karta hai aur combustion gas se steam banata hai.</p>
            </div>

            {/* Key Advantages */}
            <div style={cardStyle}>
                <h2 style={{ color: '#b91c1c' }}>Key Advantages</h2>
                <ul style={{ lineHeight: '1.8' }}>
                    <li>Eco-friendly and sustainable waste decomposition technology</li>
                    <li>No dependency on fossil fuel during regular operation</li>
                    <li>Reduces waste volume up to 1/100 - 1/400</li>
                    <li>Produces reusable heat and steam energy</li>
                    <li>Low operational and maintenance cost</li>
                    <li>Fully automatic control system with 24/7 operational capability</li>
                    <li>Supports efficient garbage management within approximately 10 Km surrounding radius</li>
                </ul>
            </div>

            {/* Applications */}
            <div style={cardStyle}>
                <h2 style={{ color: '#b91c1c' }}>Applications & Usage Areas</h2>
                <ul style={{ lineHeight: '1.8' }}>
                    <li>Government and Municipal Dumping Yards</li>
                    <li>Hospitals and Medical Facilities</li>
                    <li>Schools, Universities, and Educational Institutions</li>
                    <li>Hotels and Hospitality Sector</li>
                    <li>Agricultural Waste Management Projects</li>
                    <li>Rural Development Waste Programs</li>
                    <li>Industrial and Commercial Waste Handling Facilities</li>
                </ul>
            </div>

            {/* Technical Specifications Table */}
            <div style={cardStyle}>
                <h2 style={{ color: '#b91c1c' }}>Technical Specifications</h2>
                <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '15px' }}>
                    <thead>
                        <tr style={{ background: '#b91c1c', color: '#fff' }}>
                            <th style={{ padding: '12px', border: '1px solid #ddd', textAlign: 'left' }}>Specification</th>
                            <th style={{ padding: '12px', border: '1px solid #ddd', textAlign: 'left' }}>Details</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr><td style={{ padding: '10px', border: '1px solid #ddd' }}>Chamber Capacity</td><td style={{ padding: '10px', border: '1px solid #ddd' }}>5.0 m³</td></tr>
                        <tr><td style={{ padding: '10px', border: '1px solid #ddd' }}>Maximum Input Capacity</td><td style={{ padding: '10px', border: '1px solid #ddd' }}>4.0 m³</td></tr>
                        <tr><td style={{ padding: '10px', border: '1px solid #ddd' }}>Machine Dimensions</td><td style={{ padding: '10px', border: '1px solid #ddd' }}>2370 x 2310 x 3475 mm</td></tr>
                        <tr><td style={{ padding: '10px', border: '1px solid #ddd' }}>Weight</td><td style={{ padding: '10px', border: '1px solid #ddd' }}>Approx. 3200 kg</td></tr>
                        <tr><td style={{ padding: '10px', border: '1px solid #ddd' }}>Power Supply</td><td style={{ padding: '10px', border: '1px solid #ddd' }}>Single Phase 200V</td></tr>
                        <tr><td style={{ padding: '10px', border: '1px solid #ddd' }}>Power Consumption</td><td style={{ padding: '10px', border: '1px solid #ddd' }}>0.4 - 1.0 kW/h</td></tr>
                    </tbody>
                </table>
            </div>

            {/* Principle of Pyrolysis (Diagram added) */}
            <div style={cardStyle}>
                <h2 style={{ color: '#b91c1c' }}>Principle of Pyrolysis</h2>
                <img src={imgDiagram} alt="Process Flow" style={{ width: '100%', marginBottom: '15px', borderRadius: '8px' }} />
                <p>Negative pressure create hokar bahar se aayi hawa magnetic field se pass hoti hai. 400°C par yeh ions plasma/radical state mein convert hokar organic matter ko decompose karte hain.</p>
            </div>

            {/* Call to Action */}
            <div style={{ backgroundColor: '#1a2e4d', padding: '30px', borderRadius: '10px', color: '#fff', textAlign: 'center' }}>
                <h2>Interested in this System?</h2>
                <Link to="/enquiry">
                    <button style={{ padding: '12px 25px', background: '#ff6600', color: '#fff', border: 'none', borderRadius: '5px', cursor: 'pointer', fontSize: '1rem', marginTop: '10px' }}>
                        BOOK CONSULTATION →
                    </button>
                </Link>
            </div>
        </div>
    );
};

export default OrganicPyrolysis;